module.exports = __webpack_public_path__ + "imgs/gps.c7bb607b6d247d7995845d5341147e1a.svg";